import { Reveal, Eyebrow } from "../components/Reveal";

const POINTS = [
  "We don't believe every symptom has one hidden cause.",
  "We don't believe everyone needs dozens of supplements.",
  "We don't promise instant transformation.",
  "We don't replace necessary conventional medical care.",
  "And we don't believe a protocol is successful unless it works in real life.",
];

export const DontPromise = () => (
  <section className="bg-forestdeep relative overflow-hidden" data-testid="dont-promise-section">
    <div className="absolute inset-0 grain" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-24 lg:py-36 grid grid-cols-1 lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow light>07 · An honest manifesto</Eyebrow>
          <h2 className="mt-6 font-serif font-medium text-ivory text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
            What we don&rsquo;t promise.
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <div className="space-y-0 border-t border-ivory/15">
          {POINTS.map((p, i) => (
            <Reveal key={p} delay={0.08 * i}>
              <div className="flex gap-6 items-baseline py-6 border-b border-ivory/15">
                <span className="font-mono text-xs text-goldlight/80 shrink-0">0{i + 1}</span>
                <p className="font-serif text-xl sm:text-2xl text-ivory/90 leading-snug">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="mt-12">
            <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-goldlight">Our goal is simple</p>
            <p className="mt-4 font-serif text-2xl sm:text-3xl text-ivory leading-snug">
              Better health. <span className="text-goldlight">Better understanding.</span> Better decisions.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
